import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'zh', // 默认语言
    debug: true,
    detection: {
      order: ['querystring', 'cookie'],
      cache: ['cookie']
    },
    interpolation: {
      escapeValue: false, // React 已转义
    },
    backend: {
      loadPath: './locales/{{lng}}/{{ns}}.json', // 语言文件路径
    }
  });

export default i18n;